export type UploadScheduleStatus =
  | 'queued'
  | 'running'
  | 'complete'
  | 'failed'
  | 'cancelled';

export interface UploadScheduleItem {
  id: string;
  status: UploadScheduleStatus;
}

/** Returns queued item ids that can start without exceeding the concurrency cap. */
export function nextUploadIds(
  items: readonly UploadScheduleItem[],
  maxConcurrency: number,
): string[] {
  if (!Number.isInteger(maxConcurrency) || maxConcurrency < 1) {
    throw new RangeError('Upload concurrency must be a positive integer.');
  }

  const runningCount = items.filter((item) => item.status === 'running').length;
  const availableSlots = Math.max(0, maxConcurrency - runningCount);
  if (availableSlots === 0) return [];

  return items
    .filter((item) => item.status === 'queued')
    .slice(0, availableSlots)
    .map((item) => item.id);
}
